import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

import { jam } from "@jam.dev/sdk";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, map, tap } from 'rxjs';

import { jamActions } from '@app/auth/store/actions/jam.actions';
import { loginActions } from '@app/auth/store/actions/login.actions';
import { logoutActions } from '@app/auth/store/actions/logout.actions';
import { userInfoActions } from '@app/auth/store/actions/user-info.actions';
import { selectJamMetadata } from '@app/auth/store/selectors/jam.selectors';

@Injectable()
export class JamEffects {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

    public readonly syncJamMetadata$ = createEffect(() =>
        this.store.select(selectJamMetadata).pipe(
            distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
            tap(metadata => {
                if (!this.isBrowser) return;

                jam.metadata(() => metadata as jam.SerializableObject);
            })
        ),
        { dispatch: false }
    );

    public readonly addLoggedUserToJam$ = createEffect(() =>
        this.actions$.pipe(
            ofType(userInfoActions.success, loginActions.success),
            map(action => {
                const user = action.type === loginActions.success.type 
                    ? action.response.user 
                    : action.response;

                return jamActions.updateMetadata({ metadata: { user } });
            })
        )
    );

    public readonly removeLoggedUserFromJam$ = createEffect(() =>
        this.actions$.pipe(
            ofType(logoutActions.logout),
            map(() => jamActions.removeMetadataKey({ key: 'user' }))
        )
    );
}